module.exports = __webpack_public_path__ + "media/images/emblems/Boesingen-coat_of_arms-d5ec8843b71430283c5d31b2d27182c0.svg";